export const flattenObject = (object, separator = '.', baseName = '') => {
    let results = {};
    Object.keys(object).forEach(function (key) {
        if (typeof object[key] === 'object' && object[key] !== null) {
            results = {...results, ...flattenObject(object[key], separator, baseName + key + separator)}
        } else {
            results[`${baseName}${key}`] = object[key]
        }
    });
    return results;
};


export const flattenReduceObject = (object) => {
    let results = {};
    if(!object){
        return results;
    }
    Object.keys(object).forEach(function (key) {
        if (typeof object[key] === 'object' && object[key] !== null) {
            results = {...results, ...flattenReduceObject(object[key])}
        } else {
            results[key] = object[key]
        }
    });
    return results;
}